import { render, staticRenderFns } from "./RequestCorridor.vue?vue&type=template&id=25c9141b&scoped=true&"
import script from "./RequestCorridor.vue?vue&type=script&lang=js&"
export * from "./RequestCorridor.vue?vue&type=script&lang=js&"
import style0 from "./RequestCorridor.vue?vue&type=style&index=0&id=25c9141b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c9141b",
  null
  
)

export default component.exports